import huntingPizzaCoverImage from "../../assets/images/AllReciptsImages/huntingPizzaImages/huntingPizzaCoverImage.webp";
import huntingPizzaCoverImageMobile from "../../assets/images/AllReciptsImages/huntingPizzaImages/huntingPizzaCoverImageMobile.webp";
import huntingPizzaAboutImage from "../../assets/images/AllReciptsImages/huntingPizzaImages/huntingPizzaAboutImage.webp";
import margarittaPizzaCoverImage from "../../assets/images/AllReciptsImages/margaritaPizzaImages/margarittaPizzaCoverImage.webp";
import margarittaPizzaCoverImageMobile from "../../assets/images/AllReciptsImages/margaritaPizzaImages/margarittaPizzaCoverImageMobile.webp";
import margarittaPizzaAboutImage from "../../assets/images/AllReciptsImages/margaritaPizzaImages/margarittaPizzaAboutImage.webp";
import havaianPizzaCoverImage from "../../assets/images/AllReciptsImages/havaianPizzaImages/havaianPizzaCoverImage.webp";
import havaianPizzaCoverImageMobile from "../../assets/images/AllReciptsImages/havaianPizzaImages/havaianPizzaCoverImageMobile.webp";
import havaianPizzaAboutImage from "../../assets/images/AllReciptsImages/havaianPizzaImages/havaianPizzaAboutImage.webp";
import trianglesCoverImage from "../../assets/images/AllReciptsImages/TrianglesImages/trianglesCoverImage.webp";
import trianglesCoverImageMobile from "../../assets/images/AllReciptsImages/TrianglesImages/trianglesCoverImageMobile.webp";
import trianglesAboutImage from "../../assets/images/AllReciptsImages/TrianglesImages/trianglesAboutImage.webp";
import batonCoverImage from "../../assets/images/AllReciptsImages/BatonImages/batonCoverImage.webp";
import batonCoverImageMobile from "../../assets/images/AllReciptsImages/BatonImages/batonCoverImageMobile.webp";
import batonAboutImage from "../../assets/images/AllReciptsImages/BatonImages/batonAboutImage.webp";
import cheeseMuffinsCoverImage from "../../assets/images/AllReciptsImages/CheeseMuffinsImages/cheeseMuffinsCoverImage.webp";
import cheeseMuffinsCoverImageMobile from "../../assets/images/AllReciptsImages/CheeseMuffinsImages/cheeseMuffinsCoverImageMobile.webp";
import cheeseMuffinsAboutImage from "../../assets/images/AllReciptsImages/CheeseMuffinsImages/cheeseMuffinsAboutImage.webp";

export const RecipesPagesArrRu = [
    {
        path: "/ru/recipes/hunting-pizza",
        metaTitle: "Пицца Охотничья",
        metaDescription: "Пицца Охотничья — это вкусное блюдо с хрустящим коржом, щедро смазанным томатным соусом и оливками",
        coverImage: huntingPizzaCoverImage,
        coverImageMobile: huntingPizzaCoverImageMobile,
        coverTitle: "Пицца Охотничья",
        aboutText: "Пицца Охотничья — это вкусное блюдо с хрустящим коржом, щедро смазанным томатным соусом и оливками. Ее начинка включает ароматную охотничью колбасу, маринованные огурцы и репчатый лук, которые придают пицце насыщенный вкус. Благодаря удачному сочетанию ингредиентов, эта пицца станет идеальным выбором для настоящих ценителей мясных деликатесов.",
        aboutImage: huntingPizzaAboutImage,
        ingredients: [
          {
            title: "Сыр Украинский Pastoral",
            amount: "250 г.",
          },
          {
            title: "Мука",
            amount: "400 г.",
          },
          {
            title: "Вода",
            amount: "250 мл.",
          },
          {
            title: "Оливковое масло",
            amount: "2 ст. л.",
          },
          {
            title: "Сахар, соль, дрожжи",
            amount: "2 ч. л.",
          },
          {
            title: "Томатный соус",
            amount: "4 ст. л.",
          },
          {
            title: "Колбаса охотничья",
            amount: "150 г.",
          },
          {
            title: "Оливки",
            amount: "50 г.",
          },
          {
            title: "Лук репчатый",
            amount: "1 шт.",
          },
          {
            title: "Маринованные огурцы",
            amount: "3 шт.",
          },
        ],
        steps: [
            "В теплой воде растворите сахар и добавьте дрожжи, оставьте смесь на 10 минут для активации. После того, как дрожжи начнут действовать, добавьте соль, оливковое масло и просеянную муку.",
            "Тщательно вымесите тесто до гладкой, мягкой консистенции, чтобы оно стало эластичным под руками.",
            "После этого накройте миску чистым полотенцем и поместите тесто в теплое место на 1–1,5 часа, чтобы оно подошло и увеличилось вдвое.",
            "После того, как тесто поднимется, аккуратно обмять его, удаляя лишний воздух, и раскатать в ровный круглый пласт толщиной примерно 5–7 мм.",
            "Равномерно распределите по поверхности теста томатный соус, оставив небольшие края нетронутыми.",
            "Разложите ломтики охотничьей колбасы, маринованных огурцов, лук и оливки. Посыпьте тертым сыром Украинский Pastoral.",
            "Разогрейте духовку до температуры 220–250 °C. Выпекайте пиццу в течение 10–12 минут, пока основа не приобретет аппетитный золотистый цвет, а сыр не расплавится и не подрумянится.",
        ]
      },
      {
        path: "/ru/recipes/margaritta-pizza",
        metaTitle: "Пицца «Маргарита»",
        metaDescription: "Пицца «Маргарита» — это легендарное блюдо итальянской кухни, основой которого является тонкое тесто, покрытое ароматным томатным соусом",
        coverImage: margarittaPizzaCoverImage,
        coverImageMobile: margarittaPizzaCoverImageMobile,
        coverTitle: "Пицца «Маргарита»",
        aboutText: "Пицца «Маргарита» — это легендарное блюдо итальянской кухни, основой которого является тонкое тесто, покрытое ароматным томатным соусом, нежной моцареллой и свежими листочками базилика. Её вкусовая гармония сочетает сочность спелых помидоров, кремовую текстуру сыра и яркий аромат зелени. Простота и изысканность «Маргариты» делают её настоящим символом аутентичной итальянской кулинарной традиции.",
        aboutImage: margarittaPizzaAboutImage,
        ingredients: [
          {
            title: "Сыр «Карпатский» Pastoral",
            amount: "250 г",
          },
          {
            title: "Моцарелла Pastoral",
            amount: "50 г",
          },
          {
            title: "Мука",
            amount: "400 г",
          },
          {
            title: "Вода",
            amount: "250 мл",
          },
          {
            title: "Оливковое масло",
            amount: "2 ст. л.",
          },
          {
            title: "Сахар, соль, дрожжи",
            amount: "2 ч. л.",
          },
          {
            title: "Томатный соус",
            amount: "4 ст. л.",
          },
          {
            title: "Сметанный соус",
            amount: "2 ст. л.",
          },
          {
            title: "Помидоры",
            amount: "2 шт.",
          },
        ],
        steps: [
            "В тёплой воде растворите сахар и добавьте дрожжи, оставьте смесь на 10 минут для активации. После того как дрожжи начнут действовать, добавьте соль, оливковое масло и просеянную муку.",
            "Тщательно вымесите тесто до гладкой, мягкой консистенции, чтобы оно стало эластичным.",
            "Накройте миску чистым полотенцем и оставьте тесто в тёплом месте на 1–1,5 часа, чтобы оно поднялось и увеличилось вдвое.",
            "Когда тесто поднимется, аккуратно обомните его, удаляя лишний воздух, и раскатайте в ровный круглый пласт толщиной примерно 5–7 мм.",
            "Равномерно распределите по поверхности теста томатный и сметанный соусы, оставив небольшие края без начинки.",
            "Выложите сверху ломтики моцареллы Pastoral, посыпьте тёртым сыром «Карпатский» Pastoral и сбрызните оливковым маслом для дополнительного аромата и нежности.",
            "Разогрейте духовку до 220–250 °C. Выпекайте пиццу 10–12 минут, пока основа не станет аппетитного золотистого цвета, а сыр не расплавится и не подрумянится.",
        ]
      },
      {
        path: "/ru/recipes/havaian-pizza",
        metaTitle: "Пицца «Гавайская»",
        metaDescription: "Гавайская пицца — это неповторимое сочетание итальянской классики с экзотическим тропическим акцентом",
        coverImage: havaianPizzaCoverImage,
        coverImageMobile: havaianPizzaCoverImageMobile,
        coverTitle: "Пицца «Гавайская»",
        aboutText: "Гавайская пицца — это неповторимое сочетание итальянской классики с экзотическим тропическим акцентом. Её основу составляет тонкое тесто, покрытое сочным томатным соусом, с особым акцентом на сладких ананасах и нежной ветчине. Благодаря гармонии сладких и солёных вкусов эта пицца выделяется своей уникальностью среди других кулинарных шедевров.",
        aboutImage: havaianPizzaAboutImage,
        ingredients: [
          {
            title: "Сыр «Звенигородский» Pastoral",
            amount: "250 г",
          },
          {
            title: "Мука",
            amount: "400 г",
          },
          {
            title: "Вода",
            amount: "250 мл",
          },
          {
            title: "Оливковое масло",
            amount: "2 ст. л.",
          },
          {
            title: "Сахар, соль, дрожжи",
            amount: "2 ч. л.",
          },
          {
            title: "Томатный соус",
            amount: "4 ст. л.",
          },
          {
            title: "Ветчина",
            amount: "150 г",
          },
          {
            title: "Консервированные ананасы",
            amount: "150 г",
          },
        ],
        steps: [
            "В тёплой воде растворите сахар и добавьте дрожжи, оставьте смесь на 10 минут для активации. После того как дрожжи начнут действовать, добавьте соль, оливковое масло и просеянную муку.",
            "Тщательно вымесите тесто до гладкой, мягкой консистенции, чтобы оно стало эластичным.",
            "Накройте миску чистым полотенцем и поместите тесто в тёплое место на 1–1,5 часа, чтобы оно поднялось и увеличилось вдвое.",
            "Когда тесто поднимется, аккуратно обомните его, удаляя лишний воздух, и раскатайте в ровный круглый пласт толщиной примерно 5–7 мм.",
            "Равномерно распределите по поверхности теста томатный соус, оставив небольшие края без начинки. Выложите кусочки ветчины и ананасы. Посыпьте тёртым сыром «Звенигородский» Pastoral.",
            "Разогрейте духовку до 220–250 °C. Выпекайте пиццу 10–12 минут, пока основа не станет аппетитного золотистого цвета, а сыр не расплавится и не подрумянится.",
        ]
      },
      {
        path: "/ru/recipes/triangles",
        metaTitle: "Треугольники",
        metaDescription: "Треугольники — это аппетитные хрустящие пирожки с нежной, сочной начинкой, скрытой внутри тонкого теста",
        coverImage: trianglesCoverImage,
        coverImageMobile: trianglesCoverImageMobile,
        coverTitle: "Треугольники",
        aboutText: "Треугольники — это аппетитные хрустящие пирожки с нежной, сочной начинкой, скрытой внутри тонкого теста. Гармония расплавленного твёрдого сыра и ароматного мяса создаёт взрыв вкусов, а хрустящая золотистая корочка придаёт блюду особую текстуру. Идеальны как для быстрого перекуса, так и для изысканной подачи — треугольники добавляют вашему столу элегантность и кулинарное разнообразие.",
        aboutImage: trianglesAboutImage,
        ingredients: [
          {
            title: "Масло сливочное «Экстра» 73% Pastoral",
            amount: "200 г",
          },
          {
            title: "Сыр «Украинский» Pastoral",
            amount: "250 г",
          },
          {
            title: "Мука",
            amount: "600 г",
          },
          {
            title: "Вода",
            amount: "300 мл",
          },
          {
            title: "Уксус",
            amount: "10 г",
          },
          {
            title: "Яйцо",
            amount: "1 шт.",
          },
          {
            title: "Соль",
            amount: "5 г",
          },
          {
            title: "Готовое мясо",
            amount: "200 г",
          },
        ],
        steps: [
            "Смешайте просеянную муку с водой и яйцом, тщательно размешивая до получения однородного теста.",
            "Добавьте сливочное масло «Экстра» 73% Pastoral, щепотку соли и каплю уксуса, после чего замесите тесто вручную до эластичности.",
            "Раскатайте тесто в пласт толщиной около 5 мм, нарежьте на большие квадраты или прямоугольники, затем наполните кусочками готового мяса и сыра «Украинский» Pastoral.",
            "Закройте края каждого квадрата, формируя треугольники, и выложите на противень. Выпекайте в духовке, разогретой до 180–200 °C, в течение 25–30 минут до золотистой корочки.",
        ]
      },
      {
        path: "/ru/recipes/baton",
        metaTitle: "Батон",
        metaDescription: "Батон — это аппетитный хлеб продолговатой формы с нежной, воздушной мякотью и хрустящей золотистой корочкой",
        coverImage: batonCoverImage,
        coverImageMobile: batonCoverImageMobile,
        coverTitle: "Батон",
        aboutText: "Батон — это аппетитный хлеб продолговатой формы с нежной, воздушной мякотью и хрустящей золотистой корочкой. Его аромат во время выпечки наполняет дом уютом, а вкус идеально подходит как для простых перекусов со свежим маслом, так и для создания сложных бутербродов. Благодаря универсальности и лёгкости в приготовлении батон остаётся незаменимым в повседневном рационе.",
        aboutImage: batonAboutImage,
        ingredients: [
          {
            title: "Топлёное масло ГХИ Pastoral",
            amount: "2 ст. л.",
          },
          {
            title: "Мука",
            amount: "1 кг",
          },
          {
            title: "Вода",
            amount: "650 мл",
          },
          {
            title: "Дрожжи",
            amount: "7 г",
          },
          {
            title: "Сахар",
            amount: "1 ст. л.",
          },
          {
            title: "Соль",
            amount: "1,5 ч. л.",
          },
        ],
        steps: [
            "В тёплую воду добавьте сахар и дрожжи, перемешайте и оставьте на 10 минут, пока сверху не появится пенистая «шапочка».",
            "В большой миске просейте муку, добавьте соль, влейте активированные дрожжи и топлёное масло ГХИ Pastoral. Начните замешивать тесто ложкой, затем руками, чтобы оно начало формироваться.",
            "Вымешивайте тесто 7–10 минут, пока оно не станет мягким и эластичным.",
            "Сформируйте из теста шар, поместите его в смазанную маслом миску и накройте полотенцем или плёнкой. Оставьте в тёплом месте на 1–1,5 часа, чтобы тесто поднялось и увеличилось вдвое.",
            "После подъёма обомните тесто, придайте ему продолговатую форму батона и выложите на пергамент. Оставьте батон для второго подъёма на 30–40 минут под полотенцем.",
            "Сделайте на батоне несколько диагональных надрезов, разогрейте духовку до 200–220 °C и выпекайте около 25–30 минут, пока корочка не станет золотистой.",
        ]
      },
      {
        path: "/ru/recipes/Cheese-muffins",
        metaTitle: "Сырные кексы",
        metaDescription: "Сырные кексы — это лёгкие и нежные десерты, которые буквально тают во рту благодаря своей воздушной, пышной структуре",
        coverImage: cheeseMuffinsCoverImage,
        coverImageMobile: cheeseMuffinsCoverImageMobile,
        coverTitle: "Сырные кексы",
        aboutText: "Сырные кексы — это лёгкие и нежные десерты, которые буквально тают во рту благодаря своей воздушной, пышной структуре. Их деликатный сладкий вкус с лёгким оттенком ванили прекрасно сочетается с ароматом свежей выпечки. Идеальны как к утренней чашке кофе, так и для вкусного перекуса в течение дня — эти кексы добавят уюта любой трапезе.",
        aboutImage: cheeseMuffinsAboutImage,
        ingredients: [
          {
            title: "Масло сливочное «Экстра» 72,5% Pastoral",
            amount: "200 г",
          },
          {
            title: "Кисломолочный сыр 9% Pastoral",
            amount: "200 г",
          },
          {
            title: "Сахар",
            amount: "150 г",
          },
          {
            title: "Изюм",
            amount: "100 г",
          },
          {
            title: "Ваниль",
            amount: "10 г",
          },
          {
            title: "Яйца",
            amount: "3 шт.",
          },
          {
            title: "Соль",
            amount: "10 г",
          },
        ],
        steps: [
            "Взбейте кисломолочный сыр 9% Pastoral с яйцами до однородной, гладкой консистенции. Добавьте сахар, ваниль и щепотку соли, тщательно перемешайте все ингредиенты.",
            "Добавьте сливочное масло «Экстра» 72,5% Pastoral и снова хорошо перемешайте массу до однородности.",
            "Разлейте тесто по формочкам для кексов, добавив изюм или другую начинку по вкусу.",
            "Выпекайте в предварительно разогретой духовке при 180–200 °C в течение 35–40 минут, проверяя готовность зубочисткой — если она выходит чистой, кексы готовы.",

        ]
      },
]